import "./src/styles/global.css";


const React = require("react");
const { HelmetProvider } = require("react-helmet-async");

export const wrapRootElement = ({ element }) =>
  React.createElement(HelmetProvider, null, element);
